export default class VehiclesError extends Error {}
